import { Box, Skeleton } from '@mui/material'

export const SkeletonAccordion = () => {
  return (
    <Box sx={{ maxHeight: '400px', overflow: 'auto', marginTop: '12px', border: '1px solid #E0E0E0', width: '75%', borderRadius: '8px', padding: '12px' }}>
      {[...Array(5)].map((_, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Skeleton variant='rectangular' width={20} height={20} sx={{ mr: 2 }} />
            <Skeleton variant='text' width={200} height={24} />
          </Box>
          {/* Nested items */}
          <Box sx={{ ml: 4 }}>
            {[...Array(3)].map((_, subIndex) => (
              <Box key={subIndex} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Skeleton variant='rectangular' width={20} height={20} sx={{ mr: 2 }} />
                <Skeleton variant='text' width={150} height={20} />
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
